import React from 'react';
import { ProgressBar } from 'react-bootstrap';

import useGlobal from '../../../../../store';
import { TheError } from '../../../../../shared/responses/TheResult';

const mapState = (store) => {
  return store.app.receptores.upload;
};

const mapActions = (actions) => {
  return { ...actions.app.receptores.upload };
};

const ReceptoresUploadForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data, progress, busy, error } = state;

  const select = (event) => {
    actions.onChange({
      file: event.target.files[0],
    });
  };

  return (
    <>
      {!!error && <TheError error={error} />}

      <label>
        <input
          type="file"
          accept=".csv, .xls, .xlsx"
          onChange={select}
        />
      </label>

      <div className="p-3">
        <label>Instrucciones.</label>
        <ul className="list-unstyled">
          <li>
            1.{' '}
            <a
              target="_blank"
              href="/resources/template-receptor.xlsx"
            >
              Descarga
            </a>{' '}
            el template
          </li>
          <li>2. Sigue la guía de llenado</li>
          <li>3. Sube el archivo</li>
        </ul>
      </div>

      {(busy || progress > 0) && !!data.file && (
        <ProgressBar
          striped
          variant="info"
          label={`${progress}%`}
          now={progress}
        />
      )}
    </>
  );
};

export default ReceptoresUploadForm;
